export interface AmountSource {
  net_supported_claim?: number | null;
  result?: { final_claim_amount?: number | null } | null;
}

export function reportAmount(r: AmountSource): number | undefined {
  // Canonical sworn net (policy_deductions.net_claim) first; the stale snapshot is
  // the fallback only when no canonical net is present. This is the ONE sanctioned
  // place result.final_claim_amount is read for a dashboard figure — consumers call
  // reportAmount() rather than reading the snapshot directly.
  if (typeof r.net_supported_claim === 'number' && Number.isFinite(r.net_supported_claim)) {
    return r.net_supported_claim;
  }
  const snapshot = r.result?.final_claim_amount;  // fallback; net_supported_claim preferred above
  return typeof snapshot === 'number' ? snapshot : undefined;
}
